AGADash.Filter.Render = (function () {
    
    var createForm = function (parent) {
        var form = document.createElement("form");
        $(form).addClass("form-horizontal dash-filter-form")
            .attr("role", "form")
            .appendTo(parent);
        var div = document.createElement("div");
        $(div).addClass("form-body").appendTo(form);
        return div;
    };

    var renderFilter = function (parent, filterInfo) {
        var filter = document.createElement("div");
        $(filter).addClass("form-group dash-filter").attr({
            "filter-id": filterInfo.Id,
            "filter-type": filterInfo.Tipo
        });

        var divClass = "col-md-12";
        if (filterInfo.Label) {
            var label = document.createElement("label");
            $(label).addClass("col-md-3 control-label")
                .text(filterInfo.Label)
                .appendTo(filter);
            divClass = "col-md-9";
        }

        var div = document.createElement("div");
        $(div).addClass(divClass).appendTo(filter);

        var filterRender = AGADash.Filter.getFilterClass(filterInfo.Tipo);
        filterRender.renderFilter(div, filterInfo);

        $(filter).appendTo(parent);
    };

    var render = function (parent, filters) {

        var fragment = document.createDocumentFragment();
        var form = createForm(fragment);
        for (var i = 0; i < filters.length; i++) {
            renderFilter(form, filters[i]);
        }
        parent.appendChild(fragment);
    };
    
    return {
        render: render
    };
    
})();

AGADash.Filter.setRender(AGADash.Filter.Render);